
import React, { useState, useRef, useEffect } from "react";
import Navbar from "../components/Navbar";
import Packagedata from "../cleaning_packages.json";
import Card from "../components/card";
import SecondCard from "../components/SecondCard";
import Footer from "../components/Footer";
import PackageService from "../assets/images/packagesService.jpg";
import Garden from "../assets/images/garden.jpg";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../App.css";
import {
  kitchen1,
  houseclean,
  Floorcleaning,
  garden1,
  Glasscleaning,
  Carpet,
  Bathroom1,
  Curtains,
  MarbleFloor,
  Sofa
} from "../assets/images/Index";

const packageImages = {
  FortnightlyCleaning: Bathroom1,
  OneTimeCleaning: kitchen1,
  // MarbleFloorCleaning: MarbleFloor,
  // VinylFloorCleaning: Floorcleaning,
  // SingaporePackages: garden1,
  CarpetCleaning: Carpet,
  UpholsteryCleaning: Glasscleaning,
  CurtainSteamCleaning: Curtains,
  PostRenovationCleaning: houseclean,
  SofaCleaning: Sofa
};

const packagesList = [
  "FortnightlyCleaning",
  "OneTimeCleaning",
  // "MarbleFloorCleaning",
  // "VinylFloorCleaning",
  // "SingaporePackages",
  "CarpetCleaning",
  "UpholsteryCleaning",
  "CurtainSteamCleaning",
  "PostRenovationCleaning",
  "SofaCleaning"
];

const Packages = () => {
  const [cards] = useState(packagesList);
  const scrollRef = useRef(null);
  // const scrollInterval = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300; // how much to scroll per click
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // Dragging state
  // const isDragging = useRef(false);
  // const startX = useRef(0);
  // const scrollLeft = useRef(0);

  // // Auto-scroll function
  // const startScroll = () => {
  //   if (scrollInterval.current) return;
  //   scrollInterval.current = setInterval(() => {
  //     if (scrollRef.current && !isDragging.current) {
  //       scrollRef.current.scrollBy({ left: 2, behavior: "smooth" });

  //       // Loop first card to end
  //       const firstCard = scrollRef.current.firstChild;
  //       const { right } = firstCard.getBoundingClientRect();
  //       const { left: containerLeft } = scrollRef.current.getBoundingClientRect();
  //       if (right < containerLeft) {
  //         scrollRef.current.appendChild(firstCard);
  //         scrollRef.current.scrollLeft -= firstCard.offsetWidth;
  //       }
  //     }
  //   }, 20);
  // };

  // const stopScroll = () => {
  //   clearInterval(scrollInterval.current);
  //   scrollInterval.current = null;
  // };

  // // Mouse drag handlers
  // const handleMouseDown = (e) => {
  //   isDragging.current = true;
  //   startX.current = e.pageX - scrollRef.current.offsetLeft;
  //   scrollLeft.current = scrollRef.current.scrollLeft;
  //   stopScroll();
  // };

  // const handleMouseMove = (e) => {
  //   if (!isDragging.current) return;
  //   const x = e.pageX - scrollRef.current.offsetLeft;
  //   const walk = x - startX.current;
  //   scrollRef.current.scrollLeft = scrollLeft.current - walk;
  // };

  // const handleMouseUp = () => {
  //   isDragging.current = false;
  //   startScroll();
  // };

  // const handleMouseLeave = () => {
  //   isDragging.current = false;
  //   startScroll();
  // };

  // useEffect(() => {
  //   startScroll();
  //   return () => stopScroll();
  // }, []);

  return (
    <div>
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${Garden})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="child-block">
          <Navbar />
          <h1 className="mt-4 font-style text-light text-center" style={{ fontSize: "4rem", paddingTop: "83px" }}>
            Our Packages
          </h1>
          <p className="text-center text-light" style={{ fontSize: "1.5rem" }}>
            We offer a variety of packages to suit your needs.
          </p>
        </div>
      </div>

      <div className="px-3 px-md-5">
        {/* Weekly Packages */}
        <h3 className="mt-4" style={{ color: "#0564bf" }}>Monthly Packages</h3>
        <hr className="border-2 opacity-75" style={{ width: "240px", marginTop: "2px", color: "#0564bf" }} />
       <p className="text-muted">
         We offer flexible weekly cleaning plans tailored to your needs.
          Choose between 2-hour, 3-hour, or 4-hour sessions, with options from 
                    once a week up to five times per week. Each plan covers essential
           cleaning tasks like sweeping, mopping, dusting, and
           kitchen/bathroom cleaning.
         </p>
        <div className="d-flex flex-wrap justify-content-center gap-4">
          {Object.keys(Packagedata.MonthlyPackages).map((hourkey, index) => (
            <div key={index} className="mb-4 d-flex justify-content-center">
              <Card title={`${hourkey} Packages`} items={Packagedata.MonthlyPackages[hourkey] || []} />
            </div>
          ))}
        </div>

        {/* Other Packages Carousel */}
        <h3 className="mt-4" style={{ color: "#0564bf" }}>Other Packages</h3>
        <hr className="border-2 opacity-75" style={{ width: "200px", marginTop: "2px", color: "#0564bf" }} />
        <p className="text-muted">
         Our specialized cleaning services go beyond weekly plans. From one-time deep cleaning to marble, vinyl, carpet, and upholstery   
         treatments, these packages are designed to meet unique household needs. We also offer post-renovation cleaning,
          curtain steam cleaning,and exclusive Singapore cleaning packages to keep your home spotless and refreshed.
       </p>

        <div
          ref={scrollRef}
          className="d-flex flex-row gap-3 py-4 no-scrollbar  overflow-y-hidden overflow-x-scroll"
          // onMouseDown={handleMouseDown}
          // onMouseMove={handleMouseMove}
          // onMouseUp={handleMouseUp}
          // onMouseLeave={handleMouseLeave}
          // onMouseEnter={stopScroll}
          // style={{ cursor: isDragging.current ? "grabbing" : "grab" }}
        >
          {cards.map((pkg, idx) => (
            <div key={idx} className="scroll-card flex-shrink-0 p-2 rounded" style={{ minWidth: "280px", transition: "transform 0.3s ease" }} ata-aos="fade-left" data-aos-duration="1500">
              <SecondCard index={idx} title={pkg.replace(/([A-Z])/g, " $1")} items={Packagedata[pkg] || []} image={packageImages[pkg]} />
            </div>
          ))}
        </div>
        <div className="d-flex gap-1 d-md-flex justify-content-center">
      
        {/* Left button */}
        <button
        onClick={() => scroll("left")}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow p-2 px-4 border border-white rounded-full z-10 d-none d-md-block"
      >
        <img src="https://img.icons8.com/?size=100&id=7799&format=png&color=228BE6" style={{width:"20px", height: "20px"}}alt="" />
      </button>



       {/* Right button */}
       <button
        onClick={() => scroll("right")}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow p-2  px-4 border border-white rounded-full z-10 d-none d-md-block"
      >
        <img src="https://img.icons8.com/?size=100&id=7802&format=png&color=228BE6"style={{width:"20px", height: "20px"}}  alt="" />
      </button>
</div>



        {/* Move-In/Out + Add-ons */}
        <h3 className="mt-4" style={{ color: "#0564bf" }}>Move-In and Out</h3>
        <hr className="border-2 opacity-75" style={{ width: "220px", marginTop: "2px", color: "#0564bf" }} />
     <p className="text-muted">
         Whether you’re moving into a new place or handing over your old one,
          our Move-In and Move-Out cleaning packages ensure every corner is
          thoroughly cleaned and ready. We also provide a variety of add-ons
          like fridge cleaning, window cleaning, and more to customize your
           package for a complete cleaning experience.
        </p>

        <div className="d-flex flex-wrap justify-content-center gap-4">
          {[
            // { title: "Move-Out Cleaning SG", items: Packagedata.MoveOutCleaningSG || [] },
            // { title: "HDB Move-Out Cleaning", items: Packagedata.HDBMoveOutCleaning || [] },
             {title: "HDB MoveOut-Cleaning", items: Packagedata.HDBMoveOutCleaning || {}},
            {title : "Floor Deep Cleaning", items: Packagedata.FloorDeepCleaning ||[]},
            {title:"Condo Cleaning", items:Packagedata.CondoCleaning || {}},
           
            { title: "Add-Ons", items: Packagedata.AddOns || {} },
          ].map((pkg, idx) => (
            <div key={idx} className="d-flex justify-content-center mb-4">
              <Card title={pkg.title} items={pkg.items} />
            </div>
          ))}
        </div>
      </div>

      {/* Custom Plan Section */}
      <div
        style={{
          backgroundImage: `url(${PackageService})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "50vh",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1 }} />
        <div style={{ position: "relative", zIndex: 2, textAlign: "center", color: "white", padding: "20px" }}>
          <h1 className="mb-3 fw-bold">Need a Custom Plan?</h1>
          <p>Didn’t find the exact package you’re looking for? <br />We’ll create a personalized cleaning plan just for you.</p>
          <a href="mailto:support@Universalhra.com" className="btn btn-light px-4 py-2" style={{ borderRadius: "8px", fontWeight: "600", width: "400px" }}>
            📩 Email Us for a Custom Plan
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Packages;

